// extracted by mini-css-extract-plugin
export default {"sideMenu":"SideMenu_sideMenu__SyCmx","sideMenuRight":"SideMenu_sideMenuRight__VX+Y1"};